// REACT
import React, { Component } from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from '../../actions';

// CUSTOM COMPONENTS
import { FluidSection } from 'components/FluidSection/index';
import Booking from './Booking';

// VENDOR COMPONENTS
import CircularProgress from 'material-ui/CircularProgress';

// VENDOR UTILS
import moment from 'moment-timezone';
import isEqual from 'lodash/isEqual';

// UTILS
import {
    getTodaysDate,
    getUserTimezone,
    convertDateTimeToUserTimezone,
} from '../../utils/timezoneUtils';
import { generateToken } from 'utils/database/database-utils';
import { constants } from 'constants/index';
import { isStaging } from '../../firebase/firebase';

class UpcomingBookingsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCompletedBookings: false,
            //   todayIsConsultDay: false
        };
    }

    // ########## LIFE CYCLE HOOKS ############## //

    componentDidMount() {
        this.getUserData()
            .then(() => {
                return this.getSbmServiceId();
            })
            .then(() => {
                this.props.getSBMProviders();
                // return this.handleGetPastBookings();
            })
            .then(() => {
                // console.log('Fetched past bookings:', this.props.pastBookings);
            })
            .catch(console.log);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userId && nextProps.userData) {
            // console.log(nextProps, 'THINGS HAVE CHANGED $#$#$#', this.props.location);
            // console.log(`%c${JSON.stringify(this.props.location)}`,'color: gold');

            if (
                !isEqual(this.props.userData, nextProps.userData) ||
                !isEqual(this.props.serviceId, nextProps.serviceId)
            ) {
                this.getUserData()
                    .then(() => {
                        return this.getSbmServiceId();
                    })
                    .then(() => {
                        // console.log('GETTING SBM PROS FROM UPCOM BOOK');
                        nextProps.getSBMProviders();
                    })
                    .catch(console.log);
            }
        }
        if (!nextProps.awaitingBooking && this.props.awaitingBooking) {
            // console.log('RELOADING BOOKINGS AFTER NEW BOOKING ARRIVAL');
            this.props.loadUpcomingDbBookings({
                serviceId: nextProps.serviceId,
                userId: nextProps.userId,
                // clientUid,
                userType: 'client',
            });
        }
    }

    // ########################################### //

    getSbmServiceId = () => {
        return new Promise((resolve, reject) => {
            if (this.props.serviceSbmId) {
                // console.log('WE HAVE SBM SERVICE!');
                resolve();
            }
        });
    };

    getUserData = () => {
        return new Promise((resolve, reject) => {
            if (this.props.userId && this.props.userData) {
                resolve(this.props.userId);
            }
        });
    };

    getConsultLink = booking => {
        console.log('getting consult link');
        // const {} = booking;
        // console.log('BOOKING: ', booking);
        const userTimezone = getUserTimezone();
        const {
            companyTimezone,
            startDate,
            startTime,
            companyStartDateTime,
        } = booking; // startDate is WRONG dont use
        // const { start_date_time } = booking.confirmationData;
        const startDateTime = convertDateTimeToUserTimezone(
            companyStartDateTime,
            userTimezone,
            companyTimezone,
        );
        // console.log(startDateTime.format('YYYY-MM-DD'), 'IS START DATE TIME$$%$%$%');
        const consultStartTimestamp = moment(
            `${companyStartDateTime}`,
            'YYYY-MM-DD HH:mm:ss',
        ).format('x');

        const todaysDate = getTodaysDate(
            companyTimezone,
            companyStartDateTime,
            userTimezone,
        );

        // console.log(`%cTODAY: ${JSON.stringify(todaysDate)} ${startDate} ${startTime}`,'color: greenyellow');

        // console.log('STARTDATE', todaysDate === startDate, this.state[booking.key] && this.state[booking.key].todayIsConsultDay);
        // console.log('TODAY', todaysDate, startDate, startDateTime.format('YYYY-MM-DD'), startDateTime)

        if (
            !this.state[booking.key] &&
            (todaysDate === startDateTime.format('YYYY-MM-DD') || isStaging)
        ) {
            // console.log('Checking date...');
            console.log("either the date matched or you're on staging");
            this.setState(
                {
                    [booking.key]: {
                        todayIsConsultDay: true,
                    },
                },
                () => {
                    if (!booking.token || isStaging) {
                        // console.log('There is no existing token in DB, adding one now...');
                        this.props.generateTokenFlag(
                            booking,
                            this.props.userId,
                        );
                    }
                },
            );
        }
        // console.log('PROPS TOKEN', this.props.token);

        // IF THE BOOKINGKEY STATE HAS BEEN CREATED THEN WE CAN ASUME THAT THE TOKEN HAS BEEN SET
        if (
            booking.confirmationData &&
            this.state[booking.key] &&
            this.state[booking.key].todayIsConsultDay
        ) {
            // console.log('REDUX TOKEN/BOOKING TOKEN', this.props.token, '/', booking.token);
            return `/consultations/${booking.confirmationData.hash}${
                booking.confirmationData.code
            }`;
        } else if (booking.confirmationData) {
            return `/check-back-soon/${consultStartTimestamp}`; // ADD TIMESTAMP AS QUERY PARAM TO SHOW A COUNT DOWN?
            // return `/consultations/${booking.confirmationData.hash}${booking.confirmationData.code}`; // TODO: get rid of this FOR TESTING ONLY
        } else {
            console.log(
                'There is a problem with one of your bookings. Please contact support@cyno.ca or use the Help & Feedback form in your account menu',
                variable,
            );
        }
    };

    render() {
        // console.log('PROVIDER @ upcoming bookings',  this.props.providers);
        // console.log('FUTURE BOOKINGS', this.props.futureBookings);
        const { providers, awaitingBooking, futureBookings } = this.props;
        return (
            <React.Fragment>
                {awaitingBooking && (
                    <div
                        style={{
                            display: 'flex',
                            flex: 1,
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'center',
                            paddingBottom: 30,
                        }}
                    >
                        <CircularProgress size={100} />
                        {/* // show booking here with just date time and provider rwith spinner over it */}
                    </div>
                )}
                {futureBookings &&
                    futureBookings.length > 0 &&
                    providers &&
                    providers.length > 0 &&
                    futureBookings.map((booking, i) => {
                        const {
                            startTime,
                            startDate,
                            providerSbmId,
                            userDateTime,
                            key,
                            providerUid,
                            bookingStatus,
                        } = booking;

                        const filteredProviderArray = providers.filter(
                            provider => {
                                if (provider.uid === providerUid) {
                                    return true;
                                }
                            },
                        );
                        const bookingProviderData = filteredProviderArray[0];

                        return (
                            <Booking
                                booking={booking}
                                isConfirmed={!!booking.confirmationData}
                                isLoading={!!this.props.awaitingBooking}
                                isToday={
                                    this.state[booking.key] &&
                                    this.state[booking.key].todayIsConsultDay
                                }
                                dateTime={userDateTime}
                                bookingProviderData={bookingProviderData}
                                getConsultLink={this.getConsultLink}
                                key={i}
                                userData={this.props.userData}
                                providerUid={providerUid}
                                providers={providers}
                                status={bookingStatus}
                            />
                        );
                    })}
                {this.props.futureBookings &&
                    !this.props.futureBookings.length > 0 && (
                        <p style={styles.noBookingsNoticeStyles}>
                            There are no upcoming bookings for this{' '}
                            {this.props.userData.provider
                                ? 'client'
                                : 'service'}
                            .
                        </p>
                    )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = ({ auth, client, booking, router }) => {
    return {
        awaitingBooking: booking.awaitingBooking,
        bookings: booking.data && booking.data.bookings,
        futureBookings: booking.data && booking.data.futureBookings,
        location: router.location,
        providers: booking.providers,
        selectedProvider: booking.provider,
        userData: client.clientData,
        userId: auth.authData ? auth.authData.id : null,
    };
};

const ClientUpcomingBookings = connect(
    mapStateToProps,
    actions,
)(UpcomingBookingsComponent);

export { ClientUpcomingBookings as default };

const styles = {
    date: {
        display: 'flex',
        justifyContent: 'flex-start',
        minWidth: 105,
    },
    secondaryText: {
        display: 'flex',
        justifyContent: 'flex-end',
        minWidth: 80,
        paddingRight: 20,
    },
    noBookingsNoticeStyles: {
        paddingTop: 60,
        fontSize: constants.text.baseFontStyles.fontSize,
        textAlign: 'center',
    },
};



// WEBPACK FOOTER //
// ./src/js/components/Booking/ClientUpcomingBookings.jsx